import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

export const rootRedirectGuard: CanActivateFn = (route, state): boolean => {
  // Allow access to root path - component loading is handled by route configuration
  // The route will conditionally load activities or landing screen based on token
  return true;
};
